/* global window */

import React from 'react';
import { Provider } from 'react-redux';
import { BrowserRouter as Router, Route, browserHistory as history } from 'react-router-dom';
import { I18nProvider } from '@lingui/react';
import ProductCss from '@3plearning/3p-css-templates';

import ErrorHandling from '../../helpers/error-handling';
import { getParam, getProductById } from '../../helpers/utils';

import '../../styles/core.scss';
import BasicApp from './basic-app';

// Containers
import Console from '../console/console';
import BusyIndicator from '../busy-indicator/busy-indicator';

// catalog imports
import { DEFAULT_PRODUCT_ID } from '../../helpers/enums';

export default class EntryApp extends BasicApp {
    render(store, i18n) {
        // TODO: 4. DEFINE THE TOP-LEVEL ROUTES FOR YOUR APPLICATION'S COMPONENTS HERE

        // When executing on demo, QA, or production, the host app will inject a property
        // called pppAppConfig into the global window variable.  This will provide the
        // base name of the app.  Most of the time that will be an empty string, but in
        // case it is not, we will extract it and pass it to the router, below.
        // eslint-disable-next-line no-underscore-dangle
        const appConfig = window._env_;
        const productId = getParam('productId') || DEFAULT_PRODUCT_ID;

        const pppAppConfig = getProductById(appConfig, productId);
        ProductCss.loadCssPath(pppAppConfig.ThemeCssUrl);

        const BASE_NAME = appConfig ? appConfig.BaseName : '';

        // Add an interceptor to handle errors when accessing resources
        ErrorHandling.addResourceResponseErrorInterceptor(store.dispatch);

        // NOTE: We have used a "render" attribute, rather than "component" to specify what
        //       should be rendered.  This allows us to pass options to the component. You
        //       can obviously simplify things if your components don't need any.

        return (
            <I18nProvider i18n={i18n} >
                <Provider store={store}>
                    <Router history={history} basename={BASE_NAME}>
                        <React.Fragment>
                            <Route
                                exact
                                path="/"
                                render={() => (
                                    <Console />
                                )} />
                            <BusyIndicator />
                        </React.Fragment>
                    </Router>
                </Provider>
            </I18nProvider>
        );
    }
}

window.EntryApp = EntryApp;



// WEBPACK FOOTER //
// ./containers/app/entry-app.js